module.exports = __webpack_public_path__ + "static/media/logoDarkItesa.a4b7f4ca.svg";